const ID_CARD_VALID_TIME_SHORT = 0;
const ID_CARD_VALID_TIME_FOREVER = 1;

export  {ID_CARD_VALID_TIME_SHORT, ID_CARD_VALID_TIME_FOREVER};